import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  users: [],
  usersRef: null,
  usersLoaded: false
}

const getters = {
  users (state) {
    return state.users
  },
  usersRef (state) {
    return state.usersRef
  },
  usersLoaded (state) {
    return state.usersLoaded
  },
  userById (state) {
    return (uid) => {
      return state.users.find(u => {
        return u.uid === uid
      })
    }
  }
}

const mutations = {
  setUsers (state, payload) {
    state.users = payload
  },
  setUsersRef (state, payload) {
    state.usersRef = payload
  },
  setUsersLoaded (state, payload) {
    state.usersLoaded = payload
  }
}

const actions = {
  loadUsers: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('users')
    ref.on('value', snapshot => {
      const users = []
      snapshot.forEach(u => {
        users.push({uid: u.key, ...u.val()})
      })
      store.commit('setUsers', users)
      store.commit('setUsersRef', ref)
      store.commit('setUsersLoaded', true)
      resolve()
    })
  }),
  updateUser: (store, payload) => new Promise((resolve, reject) => {
    const user = {...payload}
    store.getters.usersRef.child(user.uid).set(user).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetUsers: (store) => new Promise((resolve, reject) => {
    if (store.getters.usersRef) store.getters.usersRef.off()
    store.commit('setUsers', [])
    store.commit('setUsersRef', null)
  }),
  resetUsersModule (store) {
    store.dispatch('resetUsers').then(() => {
      store.dispatch('resetNotes').then(() => {
        store.commit('setUsersLoaded', false)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users/users.js